import React, { PureComponent } from 'react';
import { View, Alert } from 'react-native';
import { Close } from '@dbk/ui-icons';
import { PALETTE } from '../../../../constants';
import { activeSVGStyles } from '../../../../components/common/debug-toggle/debug-toggle.styles';
import { TextInput } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';

const color = activeSVGStyles.color;

class SearchFilter extends PureComponent {
  constructor(props) {
    super(props);

    this.onChangeTextDelayed = _.debounce(this.props.updateSearchText, 800);
  }

  clearSearchText() {
    this.props.search.callClearFliter();
    var inputArea = document.getElementById("searchText");
    inputArea.value = "";
    this.props.updateSearchText('');
  }

  render() {
    const { i18n: { messages } } = this.props;
    return (
      <View className="search-bar margin-top-25">
        <View className="search-input-text">
          <TextInput
            id="searchText"
            ref="searchText"
            placeholder={messages['app.search.defaultSearch']}
            selectionColor={PALETTE.primaryText}
            autoCapitalize="none"
            onChange={(event) =>
              this.onChangeTextDelayed(event.target.value.toString())
            }
            placeholderTextColor={PALETTE.secondaryText}
          />
        </View>
        <View className="search-clear-text">
          <Close
            width={16}
            height={16}
            color={color}
            onClick={() => this.clearSearchText()}
          />
        </View>
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    search: {
      searchData: true,
      cioSearchData1: true,
      callClearFliter: {
        $call: 'clearSearchData',
      },
    },
    i18n: {
      messages: true,
    },
    platform: {
      browser: true,
    },
  },
})(SearchFilter);
